import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type InfoIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00004C14.6668 4.31814 11.6821 1.33338 8.00016 1.33338C4.31826 1.33337 1.3335 4.31814 1.33349 8.00004C1.33349 11.6819 4.31826 14.6667 8.00016 14.6667Z',
    'M8 10.6667L8 8',
    'M8 5.33337L8.00667 5.33337',
  ],
  '24': [
    'M12 22C17.5228 22 22 17.5229 22 12C22 6.47716 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z',
    'M12 16L12 12',
    'M12 8L12.01 8',
  ],
  '32': [
    'M16.0003 29.3333C23.3641 29.3333 29.3337 23.3638 29.3337 16C29.3337 8.63617 23.3641 2.66663 16.0003 2.66663C8.63653 2.66663 2.66699 8.63616 2.66699 16C2.66699 23.3638 8.63652 29.3333 16.0003 29.3333Z',
    'M16 21.3333L16 16',
    'M16 10.6666L16.0125 10.6666',
  ],
};

const InfoIcon = (props: InfoIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths?.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default InfoIcon;
